import { render } from "./CategoryOneDialog.vue?vue&type=template&id=bd1f529e&scoped=true"
import script from "./CategoryOneDialog.vue?vue&type=script&lang=ts"
export * from "./CategoryOneDialog.vue?vue&type=script&lang=ts"

import "./CategoryOneDialog.vue?vue&type=style&index=0&id=bd1f529e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-bd1f529e"

export default script
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn,QDialog});
